// LevelExam.js
import React, { useState, useEffect } from "react";
import { TextField, Typography } from "@mui/material";
import newRequest from "../../../../Utils/newRequest";

const LevelExam = ({ item, examValues, onChange, questionType }) => {
  const [availableCounts, setAvailableCounts] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  console.log(item);

  // Fetch available counts from API
  useEffect(() => {
    const fetchAvailableCounts = async () => {
      if (!item?.id) return;

      setLoading(true);
      setError(null);

      try {
        const response = await newRequest.get(
          `/questions/ByLevelCategory/${item.id}`
        );
        setAvailableCounts(response.data);
      } catch (err) {
        console.error("Error fetching available counts:", err);
        setError("Failed to load available question counts");
        // Fallback to empty counts
        setAvailableCounts({});
      } finally {
        setLoading(false);
      }
    };

    fetchAvailableCounts();
  }, [item?.id]);

  // Helper to check if entered value exceeds available count
  const isExceedingAvailable = (name, value) => {
    if (!availableCounts[name] || !value) return false;
    return parseInt(value, 10) > availableCounts[name];
  };

  const renderTextField = (label, name) => {
    const availableCount = availableCounts[name] || 0;
    const isExceeding = isExceedingAvailable(name, examValues[name]);

    return (
      <div className="question-count-field">
        <TextField
          sx={{ flex: 1 }}
          name={name}
          id={`${name}-${item.id}`}
          className="form-input"
          pattern="[0-9]*"
          label={label}
          value={examValues[name] || ""}
          onChange={(e) => onChange(name, e.target.value)}
          error={isExceeding}
          helperText={isExceeding ? "القيمة تتجاوز العدد المتاح" : ""}
          disabled={loading}
        />
        <Typography
          variant="caption"
          color="textSecondary"
          sx={{ display: "block", mt: 1 }}
        >
          الأسئلة المتاحة: {loading ? "جاري التحميل..." : availableCount}
        </Typography>
      </div>
    );
  };

  return (
    <div className="exam-container container">
      <h4>{item?.title}</h4>

      {error && (
        <Typography color="error" sx={{ mb: 2 }}>
          {error}
        </Typography>
      )}

      <div className="control-group">
        <div className="form-control">
          <label className="form-label" htmlFor={`questions_count-${item.id}`}>
            عدد الاسئلة
          </label>
          <TextField
            required
            fullWidth
            id={`questions_count-${item.id}`}
            className="form-input"
            pattern="[0-9]*"
            placeholder="أدخل عدد الاسئلة"
            name="questions_count"
            value={examValues.questions_count || ""}
            onChange={(e) => onChange("questions_count", e.target.value)}
          />
        </div>
        {questionType === 1 && (
          <div className="form-control">
            <label className="form-label" htmlFor={`question_speed-${item.id}`}>
              سرعة السؤال
            </label>
            <TextField
              required
              fullWidth
              id={`question_speed-${item.id}`}
              className="form-input"
              pattern="[0-9]*"
              placeholder="ادخل سرعة السؤال بالثانية"
              name="question_speed"
              value={examValues.question_speed || ""}
              onChange={(e) => onChange("question_speed", e.target.value)}
            />
          </div>
        )}
      </div>

      <div className="control-group">
        <div className="form-control">
          <label className="form-label" htmlFor="name">
            عدد ارقام الاسئلة
          </label>
          <div className="text-field-container">
            {renderTextField("رقمين", "questions_count_2num")}
            {renderTextField("ثلاثة ارقام", "questions_count_3num")}
            {renderTextField("اربعة ارقام", "questions_count_4num")}
            {renderTextField("خمس ارقام", "questions_count_5num")}
            {renderTextField("ستة ارقام", "questions_count_6num")}
            {renderTextField("سبعة ارقام", "questions_count_7num")}
            {renderTextField("ثمانية ارقام", "questions_count_8num")}
            {renderTextField("تسعة ارقام", "questions_count_9num")}
            {renderTextField("عشرة ارقام", "questions_count_10num")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LevelExam;
